import React from 'react';
import classNames from "classnames/bind"

import { FluidImage } from "components/shared/fluid-image/FluidImage"
import { Timeline } from './timeline/Timeline'

import styles from './about-page.module.scss';

const cx = classNames.bind(styles)

export const AboutPage = () => {
	return (
		<div className={cx("container")}> 
			<div className={cx('row')}>
				<h1 className={cx(['col-12', "animate__animated", "animate__fadeIn"])}>About Justin Ashley: Web Developer in Tampa</h1>
			</div>

			<div className={cx('row')}>
				<div className={cx(['col-12', 'col-md-8'])}>
					<h2 className={cx(["animate__animated", "animate__fadeIn"])}>My Story</h2>

					<p className={cx(["animate__animated", "animate__fadeIn"])}>I was born and predominantly raised in Montana after my father retired from the Air Force. I spent most of my youth working in the construction and tire industries, before
						I discovered Web Development and fell in love with it. I spent the next few years going through training, and then working for an awesome map company in Montana called <a href="https://www.onxmaps.com/" target="_blank" rel="noopener noreferrer" title="Click to view the onXmaps website." aria-label="Click to learn about onXmaps">onXmaps</a>.
					</p>

					<p className={cx(["animate__animated", "animate__fadeIn"])}>While I was content with the work I was doing at onXmaps, I knew I had outgrown the area (there were not many tech jobs at the level I wanted to be at). I decided to pack everything
						up into my truck, and seek work opportunity in a tech hub. I took a great road trip across the country and ended up in Florida where I stayed with a friend for a couple months
						until I found work in the Tampa area.
					</p>

					<p className={cx(["animate__animated", "animate__fadeIn"])}>I have found Tampa to be an excellent place for me, with a lot of amazing opportunities, and an atmosphere I immediately fell in love with. Currently, I am working for <a href="https://residential.masonite.com/" target="_blank" rel="noopener noreferrer" title="Click to view the Masonite website." aria-label="Click to learn about Masonite">Masonite</a> where I get to build great applications to help the company better manage it's business.
					</p>
				</div>


				<p className={cx('col-md-4', 'col-12')}>
					<span className={cx('row')}>
						<span className={cx(['tampa-web-map', 'col-12', "animate__animated", "animate__fadeInRight"])}>
							<FluidImage altText='Web map of Tampa' image='./images/about-tampa-web-developer/tampa-web-map.jpg' />
							<span className={cx(['figure'])}>Figure 1: Map of Tampa, Florida</span>
						</span>
					</span>
				</p>

			</div>

			<h2 className={cx(["animate__animated", "animate__fadeIn"])}>Education</h2>
			<p className={cx(["animate__animated", "animate__fadeIn"])}>I graduated with an <a href="https://www.sessions.edu/online-degrees/web-design/" target="_blank" rel="noopener noreferrer" aria-label="Click to learn more about the Associates Degree in Occupational Studies in Web Design.">Associates Degree in Occupational Studies in Web Design</a> from <a href="https://www.sessions.edu/" target="_blank" rel="noopener noreferrer" aria-label="Click to learn more about Sessions College">Sessions College for Professional Design</a> in the spring of 2012. Since then, I've
				continued my education and growth through reading books on different development programs, going to online coding schools (like Code School), keeping up with development
				technique sites (CSS Tricks for one), and purchasing online training through <a href="https://www.udemy.com/" target="_blank" rel="noopener noreferrer" aria-label="Click to learn more about Udemy">Udemy</a>.
			</p>

			<h2 className={cx(["animate__animated", "animate__fadeIn"])}>Professional Interests</h2>
			<p className={cx(["animate__animated", "animate__fadeIn"])}>Professionally, I enjoy working with companies where I can help them achieve core objectives, while having a positive impact on the nation.
				I prefer to work within the Front End Stack of the web application, though I don't mind working in the backend if the work is coupled together.
			</p>

			<p className={cx(["animate__animated", "animate__fadeIn"])}>I love working with small to medium teams where knowledge can be freely shared, as helping the team to grow is important to me. I like to do my job well,
				and want to see the team be successful within the company. It is important to me to produce quality work and develop solutions that solve not only today's
				problem, but is flexible enough to address reasonable shifts in the future.
			</p>

			<p className={cx(["animate__animated", "animate__fadeIn"])}>Due to my varied skills, I often find myself working in various areas as the team needs. One day, I could be designing a web page layout, another,
				building the user interaction on a form, and still another day I could be writing SQL to insert/retrieve data from the database. I'm happiest when I get to
				see how the work I do positively enhances a user's experience, while increasing the company's profit.
			</p>

			<Timeline />

			<div className={cx("fun-facts-wrapper")}>
				<h2 className={cx(["animate__animated", "animate__fadeIn"])}>Fun Facts About Justin</h2>
				<p className={cx(["animate__animated", "animate__fadeIn"])}>Here are some fun facts about me:</p>

				<ul>
					<li className={cx(["animate__animated", "animate__fadeIn"])}>I have been to Africa (specifically, Cameroon) for 3 weeks to work with children and locals there</li>
					<li className={cx(["animate__animated", "animate__fadeIn"])}>I have trained in professional ballroom dance for several years. During this time, I participated in performances to garner funds for use by Hospice Organizations. I've
						also competed in a professional West Cost Competition in Portland, Oregon, been a party guest dancer in 'The Nutcracker', and gave Swing Dance lessons at a local bar in Montana.
					</li>
					<li className={cx(["animate__animated", "animate__fadeIn"])}>I lived in Germany for 5 years, and was there when the Berlin Wall came down.</li>
					<li className={cx(["animate__animated", "animate__fadeIn"])}>I've taken numerous week long backpacking trips into the Bitterroot mountains, and participated in wilderness survival games through the Boy Scouts</li>
					<li className={cx(["animate__animated", "animate__fadeIn"])}>At one point, was ranked in 10th place in competitive PvP in GW2</li>
					<li className={cx(["animate__animated", "animate__fadeIn"])}>My team took first place in the only Startup Weekend competition I've participated in, which took place in Missoula, Montana</li>
				</ul>
			</div>
		</div>
	)
}